import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// In production on Netlify, we can use env vars. Locally, we use the config file.
const envConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  firestoreDatabaseId: import.meta.env.VITE_FIREBASE_DATABASE_ID,
};

// Fallback for AI Studio preview environment
// Use import.meta.glob to optionally import the JSON file without failing the build if missing
const localConfigs = import.meta.glob('../firebase-applet-config.json', { eager: true });
const localConfigPath = '../firebase-applet-config.json';
const fallbackConfig = localConfigs[localConfigPath] ? (localConfigs[localConfigPath] as any).default : null;

const config = envConfig.apiKey ? envConfig : (fallbackConfig || {});

export const app = initializeApp(config as any);
export const db = getFirestore(app, (config as any).firestoreDatabaseId);
export const auth = getAuth(app);


